module.exports = __webpack_public_path__ + "static/img/h1.eddb73cb.png";